const MOBILE_DEVICE_REGEX =
  /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i;
const IOS_DEVICE_REGEX = /iPhone|iPad|iPod/i;

/**
 * Checks if the device is a mobile device.
 * @returns True if the device is a mobile device, false otherwise.
 */
export const isMobileDevice = (): boolean => {
  const ua = navigator.userAgent;
  return (
    MOBILE_DEVICE_REGEX.test(ua) ||
    (navigator as Navigator & { maxTouchPoints?: number }).maxTouchPoints > 1
  );
};

/**
 * Checks if the device is an iOS device.
 * @returns True if the device is an iOS device, false otherwise.
 */
export const isIOSDevice = (): boolean => {
  return IOS_DEVICE_REGEX.test(navigator.userAgent);
};

/**
 * Checks if the device is an Android device.
 * @returns True if the device is an Android device, false otherwise.
 */
export const isAndroidDevice = (): boolean => {
  return navigator.userAgent.includes("Android");
};
